import * as React from 'react';
import { NASProductCategory } from '@websky/graphql';
import { useEveryPort } from '../../../CheckoutAdditionalService/components/EveryPortLounge/everyPort.hooks';
import ServiceSummaryDivider from '../../../ServiceSummary/components/ServiceSummaryDivider/ServiceSummaryDivider';
import ServiceSummaryOption from '../../../ServiceSummary/components/ServiceSummaryOption';
import { groupNasServices } from '../../utils';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { capitalizeFirstLetter } from '../../../utils';
import { getNasServiceCardParams } from '../../../CheckoutAdditionalService/components/EveryPortLounge/utils';
const NasSummary = ({ services, travellers, flight }) => {
    var _a, _b;
    const model = useEveryPort(NASProductCategory.lounge, '0'), data = groupNasServices(services.nas, travellers, flight.segments);
    const { t } = useTranslation(['Cart', 'Checkout']);
    const onRemoveService = (category, productId, travellerId) => {
        model.onRemoveService(productId, travellerId, category);
    };
    if (!((_b = (_a = services.nas) === null || _a === void 0 ? void 0 : _a.services) === null || _b === void 0 ? void 0 : _b.length)) {
        return null;
    }
    if (!model.selectedSummary.passengerNames.length) {
        return null;
    }
    return (React.createElement(React.Fragment, null, data.map(data => {
        const nasData = getNasServiceCardParams(data.category);
        return (React.createElement(ServiceSummaryDivider, { key: data.category },
            React.createElement(ServiceSummaryOption, { groupOption: {
                    header: t(nasData.title, { ns: 'Checkout' }),
                    items: data.travellers.map(traveller => ({
                        id: traveller.travellerId,
                        name: t('{{date}}, {{iata}}, {{travellerName}}', {
                            date: format(traveller.date, 'dd.MM.yy'),
                            travellerName: capitalizeFirstLetter(traveller.travellerName),
                            iata: traveller.segmentIata
                        }),
                        price: traveller.totalPrice,
                        onDelete: traveller.canBeDeleted
                            ? () => onRemoveService(data.category, traveller.productId, traveller.travellerId)
                            : null
                    }))
                } })));
    })));
};
export default NasSummary;
